module.exports = __webpack_public_path__ + "img/favicon.b6b5d73.png";